"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var object_fit_images_1 = __importDefault(require("object-fit-images"));
var CarsItemImg = function (_a) {
    var src = _a.src, alt = _a.alt;
    var _b = react_1.useState(false), imgIsError = _b[0], setImgError = _b[1];
    var classText = 'azgazui__cars-item-img-text';
    var classImg = 'img-object-fit';
    var textImg = react_1.default.createElement("div", { className: classText }, "\u041D\u0435\u0442 \u0438\u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F");
    var errorImg = (react_1.default.createElement("div", { className: classText },
        "\u041E\u0448\u0438\u0431\u043A\u0430 \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0438",
        react_1.default.createElement("br", null),
        "\u0438\u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F"));
    var errorHandler = function () {
        setImgError(true);
    };
    var imgEl = (react_1.default.createElement("img", { "data-testid": "img", className: classImg, src: src, alt: alt, onError: errorHandler }));
    react_1.useEffect(function () {
        // полифилл для object-fit style
        object_fit_images_1.default("." + classImg);
    }, []);
    return (react_1.default.createElement("div", { className: "azgazui__cars-item-img" }, !src ? textImg : imgIsError ? errorImg : imgEl));
};
CarsItemImg.displayName = 'CarsItemImg';
exports.default = CarsItemImg;
